import {observer} from "mobx-react";
import {DialogStore, growlStore, slsWarehouseCreateStore, validationStore} from "../../../store";
import {ModalDialog, Page, PageContentTitle} from "../../ui";
import {useState} from "react";
import {useNavigate} from "react-router";
import {SlsWarehouseForm} from "./SlsWarehouseForm";

const SlsWarehouseCreatePage = observer(function SlsWarehouseCreatePage() {
    const [cancelDialog] = useState(new DialogStore())
    const navigate = useNavigate()
    const display = `Neuen Lagerstandort anlegen`

    return <Page
        breadcrumb={[
            {
                link: '/sls',
                label: 'Einlagerung'
            },
            {
                link: '/sls/warehouse',
                label: 'Lagerstandorte'
            },
            {
                link: `/sls/warehouse/create`,
                label: display
            }
        ]}
    >
        <ModalDialog
            store={cancelDialog}
            actions={[
                {
                    label: "Abbrechen",
                    execute: async function () {
                        cancelDialog.dialogOpen = false
                    },
                    className: 'is-primary is-rounded is-small'
                },
                {
                    label: "Verwerfen",
                    execute: async function () {
                        slsWarehouseCreateStore.reset()
                        cancelDialog.dialogOpen = false
                        navigate('/sls/warehouse')
                    },
                    className: 'is-rounded is-small'
                }
            ]}
            title={"Änderungen verwerfen?"}
        >
            Sind Sie sich sicher, dass Sie die Änderungen verwerfen wollen?
        </ModalDialog>
        <PageContentTitle
            actions={[
                {
                    label: 'Speichern',
                    cls: `is-primary ${slsWarehouseCreateStore.creating ? 'is-loading' : ''}`,
                    disabled: !(slsWarehouseCreateStore.dirty && slsWarehouseCreateStore.valid),
                    action: async () => {
                        const id = await slsWarehouseCreateStore.create()
                        slsWarehouseCreateStore.reset()
                        growlStore.add({
                            message: 'Der Lagerstandort wurde erfolgreich hinzugefügt',
                            autoclose: true,
                            closable: true
                        })
                        navigate(`/sls/warehouse/${id}`)
                    }
                },
                {
                    label: 'Verwerfen',
                    cls: 'is-primary is-outlined',
                    disabled: slsWarehouseCreateStore.creating || !slsWarehouseCreateStore.dirty,
                    action: async () => {
                        cancelDialog.dialogOpen = true
                    }
                },
            ]}
        >{display}</PageContentTitle>
        <SlsWarehouseForm
            value={{
                name: slsWarehouseCreateStore.name || '',
                warehouseNumber: slsWarehouseCreateStore.warehouseNumber || '',
                addresses: slsWarehouseCreateStore.addresses,
            }}
            disabled={slsWarehouseCreateStore.creating}
            help={{
                name: validationStore.getFor('name'),
                warehouseNumber: validationStore.getFor('warehouseNumber'),
            }}
            onChange={v => {
                slsWarehouseCreateStore.name = v.name || undefined
                slsWarehouseCreateStore.warehouseNumber = v.warehouseNumber || undefined
                slsWarehouseCreateStore.addresses = v.addresses
            }}
            onDelete={(position) => slsWarehouseCreateStore.deleteAddress(position)}
            validationFor={(k: string) => validationStore.getFor(k)}
            validate={async () => slsWarehouseCreateStore.validate()}
            addAddress={async (v) => {
                slsWarehouseCreateStore.addresses = v
                await slsWarehouseCreateStore.validate()
            }}
        />
    </Page>
})

export {
    SlsWarehouseCreatePage
}
